import React from "react";
import "./MedicalAccessoriesPage.css";

const MedicalAccessoriesPage = () => {
  return (
    <>
      <div className="medicalAccessoriesSection">
        <h2>🛡 Trusted Medical Accessories for Every Home</h2>
        <div className="medicalAccessoriesContent">
          <p>
            At <strong>SwasthMitra</strong>, we understand that managing health goes beyond just medicines. That's why we offer a curated range of <strong>high-quality, essential medical accessories</strong> — to help you monitor, protect, and care for your health at home.
          </p>
          <p>
            From basic first-aid items to advanced monitoring devices, we bring you the <strong>most reliable brands at affordable prices</strong>, delivered right to your doorstep.
          </p>

          <hr />

          <h3>🔹 Explore Our Range of Medical Accessories</h3>

          <div className="accessoryCategory">
            <h4>🩺 Health Monitoring Devices</h4>
            <ul>
              <li>Digital Thermometers</li>
              <li>Blood Pressure Monitors</li>
              <li>Blood Glucose Monitors (Glucometers)</li>
              <li>Pulse Oximeters</li>
              <li>Weighing Scales</li>
              <li>Nebulizers</li>
            </ul>
            <div className="categoryNote">
              <p>Ideal for seniors, chronic illness management, or regular health tracking at home.</p>
            </div>
          </div>

          <div className="accessoryCategory">
            <h4>🧰 Home Care Essentials</h4>
            <ul>
              <li>Hot & Cold Packs</li>
              <li>Heating Pads</li>
              <li>Steam Inhalers</li>
              <li>Orthopedic Supports (knee belts, back braces, etc.)</li>
              <li>Adult Diapers & Incontinence Products</li>
            </ul>
            <div className="categoryNote">
              <p>For comfort, recovery, and day-to-day health support.</p>
            </div>
          </div>

          <div className="accessoryCategory">
            <h4>😷 Personal Protection & Hygiene</h4>
            <ul>
              <li>Face Masks (N95, surgical, reusable)</li>
              <li>Gloves (latex, nitrile)</li>
              <li>Sanitizers & Disinfectants</li>
              <li>PPE Kits</li>
              <li>First-Aid Kits</li>
            </ul>
            <div className="categoryNote">
              <p>For infection control and personal safety at home or work.</p>
            </div>
          </div>

          <div className="accessoryCategory">
            <h4>💡 Specialty Accessories</h4>
            <ul>
              <li>Digital Pregnancy Test Kits</li>
              <li>Fertility Monitors</li>
              <li>Breast Pumps</li>
              <li>Mobility Aids (Walkers, Crutches – if applicable)</li>
              <li>Medical Storage Boxes</li>
            </ul>
            <div className="categoryNote">
              <p>Supporting specific healthcare needs with precision and care.</p>
            </div>
          </div>

          <hr />

          <h3>🛒 Why Buy from SwasthMitra?</h3>
          <div className="benefits">
            <p>✅ <strong>Only Trusted Brands</strong> – No cheap duplicates or unreliable tools</p>
            <p>✅ <strong>Affordable Prices</strong> – Get the best without overpaying</p>
            <p>✅ <strong>Fast Delivery</strong> – All India shipping available</p>
            <p>✅ <strong>Customer Support</strong> – Help with product selection or usage</p>
            <p>✅ <strong>Secure Checkout</strong> – Safe payments, easy returns</p>
          </div>

          <hr />

          <div className="contactSection">
            <h3>📦 Looking for Something Specific?</h3>
            <p>
              Can't find the accessory you need?
              <br />
              We're happy to help!
              <br />
              📞 Call us: <a href="tel:+917007512120">+91-7007512120</a>
              <br />
              📧 Email: <a href="mailto:info@swasthmitra.com">info@swasthmitra.com</a>
            </p>
          </div>

          <div className="closingSection">
            <h3>💬 Your Health is in Your Hands — We Help You Take Care of It</h3>
            <p>
              Whether you're managing a health condition, caring for a loved one, or simply being proactive — <strong>SwasthMitra's medical accessories</strong> help make healthcare safer and simpler at home.
            </p>
            <div className="shopButtonContainer">
              <button className="shopButton">Browse Our Full Range</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MedicalAccessoriesPage;